
import React, { useState } from "react";
import { ReviewForm, type ReviewFormData } from "@/components/ReviewForm";
import { useTranslation } from "@/hooks/useTranslation";
import type { Review } from "@/types/review";

interface EditReviewContentProps {
  review: Review;
  isSubmitting: boolean;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  onCancel: () => void;
  onAirportSelect: (airport: any) => void;
  onFormDataChange: (newData: Partial<ReviewFormData>) => void;
}

export function EditReviewContent({
  review,
  isSubmitting,
  onSubmit,
  onCancel,
  onAirportSelect,
  onFormDataChange
}: EditReviewContentProps) {
  const { t } = useTranslation();
  const [formData, setFormData] = useState<ReviewFormData>({
    airport_name: review.airport_name,
    airport_location: review.airport_location,
    review_text: review.review_text,
    film_friendly_score: review.film_friendly_score,
    hand_check_success: review.hand_check_success,
    latitude: review.latitude?.toString() || "",
    longitude: review.longitude?.toString() || "",
    terminal: review.terminal || "",
    hand_check_date: review.hand_check_date || ""
  });

  const handleFormDataChange = (data: Partial<ReviewFormData>) => {
    const updatedData = { ...formData, ...data };
    setFormData(updatedData);
    onFormDataChange(data);
  };

  return (
    <div className="space-y-8">
      <h2 className="text-xl font-semibold">{t('edit_review')}</h2>
      
      <ReviewForm
        formData={formData}
        isSubmitting={isSubmitting}
        onSubmit={onSubmit}
        onCancel={onCancel}
        onAirportSelect={onAirportSelect}
        onFormDataChange={handleFormDataChange}
      />
    </div>
  );
}
